import { PartialProduct } from "@shared/types";
import { AppContext } from "context/app";
import { CartContext } from "context/cart";
import { getEcommerceWithValue } from "helpers/analyticsLogger";
import { useCartAnalyticsEvents } from "hooks/analytics/useCartAnalyticsEvents";
import { useProductsCylinderAnalytics } from "hooks/analytics/useProductsCylinderAnalytics";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { GetItemsByGtinQuery } from "services/graphql/generated";

export const useAddCylinderToCart = (
  allCylindersData: GetItemsByGtinQuery | undefined,
  analyticsCategoryName: string | null | undefined,
) => {
  const [cartLoading, setCartLoading] = useState(false);

  const router = useRouter();
  const { addToCartEvent } = useCartAnalyticsEvents();
  const { tenant } = useContext(AppContext);
  const currency = tenant?.checkout?.paymentOptions?.defaultCurrencyCode || "";
  const { itemsForLogging } = useProductsCylinderAnalytics(
    currency,
    allCylindersData,
    analyticsCategoryName,
  );
  const { updateCartItem } = useContext(CartContext);

  const handleAddCylinderToCart = async (
    productId: string,
    quantity: number,
  ) => {
    setCartLoading(true);
    const analyticsItem = itemsForLogging.find(
      (item) => item.itemId === productId,
    ) as PartialProduct;
    analyticsItem.quantity = quantity;
    const ecommerce = getEcommerceWithValue({
      currency,
      itemListName: undefined,
      items: [analyticsItem],
    });
    const newCart = await updateCartItem({
      productId,
      quantity,
      subscriptionIntervalInDays: null,
      analyticsDetails: ecommerce,
      includeExistingQuantity: true,
    });
    await addToCartEvent(newCart, ecommerce);

    router.push("/cart");

    const handleRouteChangeComplete = () => {
      setCartLoading(false);
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
    router.events.on("routeChangeComplete", handleRouteChangeComplete);
  };

  return { handleAddCylinderToCart, cartLoading };
};
